import React, { useMemo } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate, Outlet } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import urls from '@app/routes/urls'
import { setAbility } from '../Auth/ability'
import { AbilityContext } from '../Auth/AbilityContext'
import AlertProvider from '../Alerts'

const ProtectedRoute = () => {
  const auth = useAuth()
  const { isAuthenticated, isLoading, signinRedirect } = auth

  const ability = useMemo(() => {
    if (auth.user) {
      const decoded = jwtDecode(auth.user.access_token) as { resource_access: { [key: string]: { roles: string[] } } }
      const roles = decoded.resource_access[KEYCLOAK_ROLE_RESOURCE]?.roles ?? ['']
      return setAbility(roles[0])
    }
    return setAbility('')
  }, [auth.user])

  // Not authenticated, redirect to login
  if (!isLoading && !isAuthenticated) {
    signinRedirect()
  }

  // Loading, return a loading indicator
  if (isLoading) {
    // We can get stuck here if logged in but not on the VPN
    // In this scenario isLoading = true and isAuthenticated = false
    return <div>Loading...</div>
  }

  // Authenticated, return the requested route
  if (!isLoading && isAuthenticated) {
    if (!ability.can('read', 'All')) {
      return <Navigate to={urls.accessDenied} />
    }

    return (
      <AbilityContext.Provider value={ability}>
        <AlertProvider>
          <Outlet />
        </AlertProvider>
      </AbilityContext.Provider>
    )
  }

  // Default, return a loading indicator
  return <div>Erroring...</div>
}

export default ProtectedRoute
